<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout wrap>
      <v-flex>
          <h3>Welcome to the SoftPro Atmos portal!</h3>
          <p>This portal is the primary location for the management of your SoftPro software.</p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
}
</script>
